import * as moment from 'moment';

export interface IOTPModel {
  token: string;
  token_expiry_time: moment.Moment;
  otp_expiry_time: moment.Moment;
  is_phone_verified: boolean;
  resend_otp_delay:number;
  login_method: string;
  csrf_token: string;
}

function handleOtpExpiry(otp_expiry_time: any, resend_opt_delay: number): moment.Moment {
  if (!otp_expiry_time) {
    return moment().add(resend_opt_delay, 'minutes');
  } else {
    return moment(otp_expiry_time);
  }
}
export class OtpModel {
  token: string;
  tokenExpiryTime: moment.Moment;
  optExpiryTime: moment.Moment;
  isPhoneVerified: boolean;
  resendOtpDelay: number;
  loginMethod: string;

  static fromObject(opt: IOTPModel): OtpModel {
    let obj = new OtpModel();
    obj.token = opt.token;
    obj.tokenExpiryTime = moment(opt.token_expiry_time);
    obj.optExpiryTime = handleOtpExpiry (opt.otp_expiry_time, opt.resend_otp_delay);
    obj.isPhoneVerified = opt.is_phone_verified;
    obj.resendOtpDelay = opt.resend_otp_delay;
    obj.loginMethod = opt.login_method
    return obj;
  }
}
